import React from 'react';
import data from '../data.json';

export default function Footer() {
  const { company, nav, services } = data;
  const year = new Date().getFullYear();

  return (
    <footer style={{
      borderTop: '1px solid var(--border)',
      background: 'var(--bg-dark)',
      padding: '68px 0 28px',
    }}>
      <div className="container">
        <div style={{
          display: 'grid', gridTemplateColumns: '2.2fr 1fr 1fr 1fr',
          gap: 48, marginBottom: 52,
        }} className="footer-grid">

          {/* Brand */}
          <div>
            <div style={{ fontSize: '1.55rem', fontWeight: 900, marginBottom: 13, letterSpacing: '-0.02em' }}>
              Vy<span style={{ color: 'var(--accent)' }}>linx</span>
            </div>
            <p style={{
              color: 'var(--gray-500)', fontSize: 13, lineHeight: 1.82,
              maxWidth: 255, marginBottom: 20,
            }}>
              Born in Kolkata. Built for the world. A fresh digital marketing startup committed to making your brand our best story.
            </p>
            <div style={{ fontSize: 13, color: 'var(--gray-500)', lineHeight: 1.9 }}>
              📍 {company.location}<br />
              <a href={`mailto:${company.email}`} style={{ color: 'var(--accent2)' }}>
                {company.email}
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <div style={{ color: '#fff', fontWeight: 800, fontSize: 11.5, marginBottom: 18, textTransform: 'uppercase', letterSpacing: 1.5 }}>
              Services
            </div>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 11 }}>
              {services.slice(0, 5).map(s => (
                <li key={s.id}>
                  <a href="#services" style={{ color: 'var(--gray-500)', fontSize: 13, transition: 'color var(--ease)' }}
                    onMouseEnter={e => e.target.style.color = 'var(--accent2)'}
                    onMouseLeave={e => e.target.style.color = 'var(--gray-500)'}
                  >{s.title}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* More services */}
          <div>
            <div style={{ color: '#fff', fontWeight: 800, fontSize: 11.5, marginBottom: 18, textTransform: 'uppercase', letterSpacing: 1.5 }}>
              More
            </div>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 11 }}>
              {services.slice(5).map(s => (
                <li key={s.id}>
                  <a href="#services" style={{ color: 'var(--gray-500)', fontSize: 13, transition: 'color var(--ease)' }}
                    onMouseEnter={e => e.target.style.color = 'var(--accent2)'}
                    onMouseLeave={e => e.target.style.color = 'var(--gray-500)'}
                  >{s.title}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <div style={{ color: '#fff', fontWeight: 800, fontSize: 11.5, marginBottom: 18, textTransform: 'uppercase', letterSpacing: 1.5 }}>
              Company
            </div>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 11 }}>
              {nav.map(item => (
                <li key={item.id}>
                  <a href={item.href} style={{ color: 'var(--gray-500)', fontSize: 13, transition: 'color var(--ease)' }}
                    onMouseEnter={e => e.target.style.color = 'var(--accent2)'}
                    onMouseLeave={e => e.target.style.color = 'var(--gray-500)'}
                  >{item.label}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{
          borderTop: '1px solid var(--border)', paddingTop: 26,
          display: 'flex', justifyContent: 'space-between',
          alignItems: 'center', flexWrap: 'wrap', gap: 12,
        }}>
          <span style={{ color: 'var(--gray-500)', fontSize: 12 }}>
            © {year} Vylinx. All rights reserved.
          </span>
          <div style={{ display: 'flex', gap: 20 }}>
            {['Privacy Policy', 'Terms of Service'].map(item => (
              <a key={item} href="#" style={{ color: 'var(--gray-500)', fontSize: 12, transition: 'color var(--ease)' }}
                onMouseEnter={e => e.target.style.color = '#fff'}
                onMouseLeave={e => e.target.style.color = 'var(--gray-500)'}
              >{item}</a>
            ))}
          </div>
        </div>

        {/* Bengali pride */}
        <div style={{
          textAlign: 'center', paddingTop: 16,
          fontSize: 13, color: '#3F4967', fontStyle: 'italic',
        }}>
          আমাদের শহর, আমাদের গর্ব — Made with ❤️ in Kolkata &nbsp;|&nbsp; কলকাতা থেকে বিশ্বে
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .footer-grid { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 560px) {
          .footer-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </footer>
  );
}
